"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendAlgoliaObjectIdsConvertedAfterSearchEvent = exports.sendAlgoliaObjectIdsClickedAfterSearchEvent = exports.formatAlgoliaAnalyticsEventName = exports.enhanceAlgoliaAnalyticsTags = void 0;
const enums_1 = require("../enums");
const enhanceAlgoliaAnalyticsTags = ({ isDesktop, analyticsTags, }) => {
    if (typeof window !== 'undefined') {
        analyticsTags.push(isDesktop ? enums_1.AlgoliaAnalyticsTag.Desktop : enums_1.AlgoliaAnalyticsTag.Mobile);
    }
    return analyticsTags;
};
exports.enhanceAlgoliaAnalyticsTags = enhanceAlgoliaAnalyticsTags;
const formatAlgoliaAnalyticsEventName = ({ page, source, action, }) => {
    return [page, source, action].join(';');
};
exports.formatAlgoliaAnalyticsEventName = formatAlgoliaAnalyticsEventName;
const sendAlgoliaObjectIdsClickedAfterSearchEvent = ({ insightsClient, eventName, indexName, queryId, objectIds, positions, }) => {
    insightsClient('clickedObjectIDsAfterSearch', {
        eventName: (0, exports.formatAlgoliaAnalyticsEventName)(eventName),
        index: indexName,
        queryID: queryId,
        objectIDs: objectIds,
        positions,
    });
};
exports.sendAlgoliaObjectIdsClickedAfterSearchEvent = sendAlgoliaObjectIdsClickedAfterSearchEvent;
const sendAlgoliaObjectIdsConvertedAfterSearchEvent = ({ insightsClient, eventName, indexName, queryId, objectIds, }) => {
    insightsClient('convertedObjectIDsAfterSearch', {
        eventName: (0, exports.formatAlgoliaAnalyticsEventName)(eventName),
        index: indexName,
        queryID: queryId,
        objectIDs: objectIds,
    });
};
exports.sendAlgoliaObjectIdsConvertedAfterSearchEvent = sendAlgoliaObjectIdsConvertedAfterSearchEvent;
//# sourceMappingURL=algoliaAnalytics.js.map